import '../../core/iberapi/hotels_data/hotels_data'

let fastbooking_data = null
let destinations_data = null
let mice_specialty_id = null
let $fastbooking = null
const isMobile = IB.currentDevice === 'mobile'

function init() {
  const fastbookingMeetings = isMobile ? document.querySelector('.mobile-fastbooking-form.meetings') : document.querySelector('#fastbooking-meetings .fastbooking')
  if (!fastbookingMeetings) return false

  //Jquery variable to keep the previous logic
  $fastbooking = $(fastbookingMeetings)

  if (IB.hotels_data.check()) {
    initialFunctions()
  } else {
    IB.hotels_data.get(function () {
      initialFunctions()
    })
  }

  // Get values from cookie
  let default_values = $.cookie('meetings_search')

  if (default_values) {
    default_values = JSON.parse(default_values)
    for (const name in default_values) {
      if (default_values[name] !== null && default_values[name].length) {
        const this_input = $fastbooking.find(`[name*="${name}"]`)

        if (this_input.is('select')) {
          if ($fastbooking.find('.fake-select-mice').length) {
            if (this_input.hasClass('chosen-select')) {
              setTimeout(() => {
                this_input.val(default_values[name])
                initSelect(this_input, this_input.parent().find('span.fake-select-mice'))
              }, 0)
            } else {
              !this_input.hasClass('js-is-native-select') && this_input.formikation()
              this_input.val(default_values[name])
              this_input.trigger('change')
            }
          } else if (this_input.hasClass('chosen-select')) {
            this_input.val(default_values[name])
            this_input.trigger('chosen:activate')
          } else {
            !this_input.hasClass('js-is-native-select') && this_input.formikation()
            this_input.val(default_values[name])
            this_input.trigger('change')
          }
        } else {
          this_input.val(default_values[name])
        }
      }
    }
  }

  fastbookingMeetings.querySelectorAll('.fake-select-mice').forEach(selector => {
    selector.addEventListener(
      'click',
      function (event) {
        event.preventDefault()
        const $this = $(this)
        const $chosen_selector = $this.parent().find('select.chosen-select')
        initSelect($chosen_selector, $this)
        setTimeout(() => {
          $chosen_selector.trigger('chosen:open')
        }, 0)
      },
      false
    )
  })

  fastbookingMeetings.querySelectorAll('.fake-input-mice').forEach(selector => {
    selector.addEventListener('click', function (event) {
      const fake_input = this
      fake_input.parentNode.querySelector('input').focus()
      fake_input.style.display = 'none'
      fake_input.parentNode.querySelector('input').addEventListener('blur', function () {
        fake_input.style.display = 'block'
      })
    })
  })

  $(document)
    .on('click touchend', '.fastbooking .secondary-btn', function () {
      $(this).closest('select').trigger('chosen:close')
    })
    .on('click', '.fastbooking .quote', function () {
      const $filter = $('.hotels-info-with-filtering')
      if ($filter.length) {
        $filter.find('.action .btn-primary').trigger('click')
      } else {
        const href = $fastbooking.data('new-meetings-search-path')
        const rooms = $('#mice-rooms').find('input').val()
        const people = $('#mice-people').find('input').val()
        let budget = $('#mice-budget').find('select').val()
        let spec = $('#desktop-specialties').find('select').val()

        budget = budget != null ? budget.join('+') : ''
        spec = spec != null ? spec.join('+') : ''

        window.location.href = `${href}meeting_rooms_number=${rooms}&people_number=${people}&meeting_rooms_budget_range_id=${budget}&hotel_specialty_id=${spec}`
      }
      // GTM events
    })
    .on('change', '#vo_meetings_search_destination_id, #vo_meetings_search_meeting_rooms_budget_range_id, #vo_meetings_search_hotel_specialty_id', function () {
      const $that = $(this)
      // Como tarda en actualizarse, sin el setTimeout si deseleccionamos sale aún como seleccionado
      setTimeout(function () {
        let selected_text = ''
        $that
          .parent()
          .find('.search-choice span')
          .each(function () {
            selected_text += ` | ${$(this).text()}`
          })
      }, 500)
    })

  if (IB.currentDevice !== 'mobile') {
    let top_scroll_trigger = $fastbooking.offset().top

    if ($('.meetings-search-engine .fastbooking').length) {
      top_scroll_trigger = $('.meetings-search-engine .fastbooking').offset().top
    }

    $(window).on('scroll', function () {
      const window_scroll = $(window).scrollTop()

      if (window_scroll > top_scroll_trigger) {
        if (!$('.fastbooking-placeholder').find('.fastbooking').length) {
          $fastbooking.appendTo('.fastbooking-placeholder')
        }
        $(':focus').trigger('blur')
        $('#fastbooking-meetings').css('height', $fastbooking.outerHeight())
      } else {
        if ($('.fb-mice-results').length) {
          $fastbooking.appendTo('#fastbooking-meetings')
        } else {
          $fastbooking.appendTo('#fastbooking-meetings')
        }
        $('#fastbooking-meetings').removeAttr('style')
      }
    })
  }

  if (IB.currentDevice === 'mobile') {
    $(document)
      .on('click touchend', '.mobile-fastbooking-form.meetings .secondary-btn', function () {
        $fastbooking.find('.opened').removeClass('opened')
      })
      .on('click touchend', '.mobile-fastbooking-form.meetings .submit', function () {
        $('.mobile-fastbooking-form.meetings').parsley()
      })
  }

  // Includes GTM events (at RFP form) for hotels and date
  if ($('.quote-form-wrapper').length) {
    $(document).on('change', '#hotel_ids_', function () {
      const $that = $(this)
      // Como tarda en actualizarse, sin el setTimeout si deseleccionamos sale aún como seleccionado
      setTimeout(function () {
        let selected_text = ''
        $that
          .parent()
          .find('.search-choice span')
          .each(function () {
            selected_text += ` | ${$(this).text()}`
          })
      }, 500)
    })
  }
}

function initSelect($select, $fake_select = null) {
  if (!$fastbooking) {
    $fastbooking = isMobile ? $('.mobile-fastbooking-cnt') : $('.fastbooking')
  }

  if ($fake_select) {
    $fake_select.remove()
  }

  $select
    .chosen({
      group_search: false,
      disable_search_threshold: 5,
      inherit_select_classes: true,
    })
    .on('change', function () {
      const $this = $(this)

      if ($this.attr('id') === 'vo_booking_place_to_go' || $this.attr('id') === 'mobile-hotels-selector') {
        $this.parents('form').attr('data-user-input', 'NAN')
      }

      if ($fastbooking === undefined) return false
    })
    .on('chosen:no_results', function (e, params) {
      const $el = $(this)
      const $error_el = $el.siblings('.error-placeholder').clone()
      const sentGA = false
      $error_el.find('.no-results.for').append(`: ${params.chosen.search_field.val()}`)
      $el.siblings('.chosen-container').find('.chosen-results').html($error_el.html())

      /* $('.more-hotels a').on('touchstart click', function(event) {
      e.preventDefault();
      window.location = $(this).attr('href');
    });*/

      $('#book-now').on('click', function (event) {
        $(this).addClass('mouse-down')
      })
    })
    .on('chosen:showing_dropdown', function () {
      if ($fastbooking === undefined) return false
      const $this = this
      $this.parentNode.querySelector('.chosen-results').style.display = 'block'

      if ($('body').hasClass('mice-home') && IB.currentDevice === 'mobile') {
        // element_bottom = $el.offset().top + $el.outerHeight();
        $('html,body').animate(
          {
            scrollTop: $fastbooking.offset().top - 40,
          },
          500
        )
      }

      if (IB.currentDevice !== 'mobile') {
        ifElementOnScreen($(this).closest('div').find('.chosen-drop'))
      }
    })
    .on('chosen:change_before_hide', function (e, selectedParam) {
      // IMPORTANT: this event fires before change and chosen:hiding_dropdown
    })
    .on('chosen:hiding_dropdown', function (e, params) {
      let fake_select = this.parentNode.querySelector('.fake-select-mice')
      if (!fake_select) {
        fake_select = document.createElement('span')
        fake_select.classList.add('fake-select-mice')
        this.parentNode.appendChild(fake_select)
        fake_select.addEventListener('click', function (event) {
          event.preventDefault()
          const $chosen_selector = $(fake_select).parent().find('select.chosen-select')
          setTimeout(() => {
            $chosen_selector.trigger('chosen:open')
          }, 0)
        })
      }
    })
  fastbooking_data = IB.hotels_data.getData()
}

function ifElementOnScreen($el) {
  const scroll_bottom = $(window).height() + $(window).scrollTop()
  const element_bottom = $el.offset().top + $el.outerHeight()
  if (scroll_bottom < element_bottom) {
    $('html,body').animate(
      {
        scrollTop: $(window).scrollTop() + element_bottom - scroll_bottom + 20,
      },
      500
    )
  }
}

function initialFunctions() {
  // Getting common data
  fastbooking_data = IB.hotels_data.getData()
  //let mice_specialty = fastbooking_data.specialties[1].filter(function (elem) {return elem.visible_in_mice;});
  //mice_specialty_id = parseInt(mice_specialty[0].id.substring(1));
  // Eso no está funcionando en tanto la especialidad MICE ya no viene dentro de fastbooking_data.specialties y, de todos modos,
  // visible_in_mice es que esté visible en MICE no que sea la especialidad de MICE. No hay nada que identifique a MICE expresamente
  // como MICE salvo el nombre, luego o bien se mira por nombre en API si devuelve al fastbooking_data y lo leemos o asumimos que la BD
  // no va a cambiar ya y metemos el ID.
  mice_specialty_id = 39

  // init different selects
  initSelectSpecialties()
  initSelectDestinations()
  initSelectBudgets()
}

function initSelectSpecialties() {
  const $select = $fastbooking.find('.specialties select')

  if (!$select.length) return false

  // Construimos las opciones del select
  const specialties_data = fastbooking_data.specialties[1].filter(function (elem) {
    return elem.visible_in_mice
  })
  const specialties_options = getOptions(specialties_data, true)

  $select.append(specialties_options)
}

function initSelectBudgets() {
  const $select = $fastbooking.find('.budget select')

  if (!$select.length) return false

  // Construimos las opciones del select
  const budget_data = fastbooking_data.budgets[1]
  const budget_options = getOptions(budget_data, false)

  $select.append(budget_options)
}

function initSelectDestinations() {
  const $select = $fastbooking.find('.place-to-go-mice select')

  if (!$select.length) return false

  let hotels_data = fastbooking_data.hotels[1]
  hotels_data = hotels_data.filter(belongsToMice)
  // Cacheamos los JSON de destinos y de especialidades
  destinations_data = fastbooking_data.destinations[1]

  const arr_d_ids = filterDestinationsByHotels(hotels_data)

  filterDestinations(arr_d_ids)

  // Construimos las opciones del select
  const $destinations_group = getOptionsGroup(destinations_data, fastbooking_data.destinations[0], 'destinations')
  const $hotels_group = getOptionsGroup(hotels_data, fastbooking_data.hotels[0], 'hotels')

  $select.append($destinations_group, $hotels_group)
}

function filterDestinationsByHotels(hotels_data) {
  let h_for
  let d_id
  let d_for
  let p_id
  let depth
  let arr
  let arr_d_ids = []
  let dest

  // Agregamos a cada hotel sus destinos
  for (let i = hotels_data.length - 1; i >= 0; i--) {
    arr = []
    // Cacheamos el objeto de hotel
    h_for = hotels_data[i]

    d_id = h_for.data.destination
    // Buscamos el objeto destino más inmediato
    d_for = filterByDestinationId(d_id)

    // Si no encontramos el objeto de destino, no ejecutamos el resto
    if (d_for === undefined) return
    // Si el objeto de destino existe, lo pusheamos al all_dest
    arr.push(d_id)
    // Guardamos el nivel de profundidad del destino
    depth = d_for.data.depth
    // Si el nivel de profundidad es menor que 1, no ejecutamos el resto
    if (depth < 1) return
    // Si el nivel de profundiad es igual o mayor que 1, guardamos el parent_id del destino
    p_id = d_for.data.parent_id
    // Creamos un bucle para recorrer los niveles de profundiad
    for (let d = depth; d > 0; d--) {
      // Cada vez que recorremos el bucle buscamos el objeto del destino con el id igual al parent_id
      dest = filterByDestinationId(p_id)
      // Si dest nos retorna como undefined, paramos
      if (dest === undefined) break
      // Si el objeto existe puesheamos su id al all_dest y sobreescribimos la variable parent_id
      arr.push(p_id)
      p_id = dest.data.parent_id
    }
    h_for.all_dest = arr || []
    arr_d_ids = arr_d_ids.concat(arr)
  }
  return arr_d_ids
}

function getOptionsGroup(data, label, groupclass) {
  const $opt_group = $(`<optgroup class="${groupclass}" label="${label}"></optgroup>`)
  data.sort(compareByTitle)
  for (let i = data.length - 1; i >= 0; i--) {
    $opt_group.prepend(createOption(data[i]))
  }
  return $opt_group
}

function getOptions(data, sort) {
  let all_options = ''
  if (sort) {
    data.sort(compareByTitle)
  }
  for (let i = data.length - 1; i >= 0; i--) {
    all_options = createOption(data[i]) + all_options
  }
  return all_options
}

function createOption(data) {
  const $el = $(`<option value="${data.id}">${data.title}</option>`)
  if (data.translation_list) {
    $el.attr('data-translations', data.translation_list)
  }
  return $el.get(0).outerHTML
}

function compareByTitle(a, b) {
  return a.title.localeCompare(b.title)
}

function filterByDestinationId(id) {
  const data = destinations_data.filter(function (el) {
    return el.id === id
  })
  if (data.length) return data[0]
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index
}

function filterDestinations(d_ids) {
  // Sacamos los ids unicos de destinos y construimos un nuevo destination_data con los destinos disponibles.
  let d
  const ids = d_ids.filter(onlyUnique)
  const d_arr = []

  for (let i = ids.length - 1; i >= 0; i--) {
    d = filterByDestinationId(ids[i])
    if (d.data.depth == 1) {
      d_arr.push(d)
    }
  }
  destinations_data = d_arr
}

function belongsToMice(elem) {
  if (elem.data.specialties.indexOf(mice_specialty_id) > -1) {
    return true
  }
  return false
}

init()
